export default {
  data() {
    return {
      customValidators: {}
    }
  },
  methods: {
    mapValidationFunctions() {
      if(!this.customFormValidation) console.error('Please define "customFormValidation" in you Component to be able to use Custom Validations')
      Object.keys(this.customFormValidation).forEach((fieldName) => {
        if(fieldName) this.$set(this.customValidators, [fieldName], {})

        Object.keys(this.customFormValidation[fieldName]).forEach(key => {
          if(key) this.$set(this.customValidators[fieldName], [key], {})
          let validator = this.customFormValidation[fieldName][key]

          if(validator.translate_message && validator.translate_message.length) this.customValidators[fieldName][key]['translate_message'] = this.$i18n.t(validator.translate_message, [fieldName])
          if(validator.message && validator.message.length) this.customValidators[fieldName][key]['message'] = validator.message
          if(validator.validation && validator.validation.length) this.$set(this.customValidators[fieldName][key], 'validation', this[validator.validation])
        })
      })
    }
  }
}